export class CardModel {
  cardId: string = undefined;
  cardTitle: string = undefined;
  weekThemeId: string = undefined;    // topicKey
  plannerGroupId: string = undefined;
  cardDescription: string = undefined;
  cardNotes: string = undefined;
}
